<app-auth-card
  [loader]="resetPasswordComponentLoader"
  [title]="'auth.resetPassword.title' | translate"
  [description]="'auth.resetPassword.description' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.token"
        for="token"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.forgotPassword.verificationCode' | translate }}</label
      >
      <input
        pInputText
        id="token"
        type="text"
        autocomplete="one-time-code"
        class="w-full"
        formControlName="token"
        [placeholder]="'auth.forgotPassword.verificationCode' | translate"
      />
      <app-form-error [control]="editForm.controls.token" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.password"
        for="password"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.forgotPassword.newPassword' | translate }}</label
      >
      <p-password
        inputId="password"
        formControlName="password"
        autocomplete="new-password"
        [placeholder]="'auth.forgotPassword.newPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [fluid]="true"
      />
      <app-form-error [control]="editForm.controls.password" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.confirmPassword"
        for="confirmPassword"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.forgotPassword.confirmPassword' | translate }}</label
      >
      <p-password
        inputId="confirmPassword"
        formControlName="confirmPassword"
        autocomplete="new-password"
        [placeholder]="'auth.forgotPassword.confirmPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [fluid]="true"
      />
      <app-form-error [control]="editForm.controls.confirmPassword" />
    </div>

    <p-button
      type="submit"
      [label]="'auth.forgotPassword.save' | translate"
      icon="pi pi-check"
      size="large"
      styleClass="w-full"
    />
  </form>

  <div class="mt-6 text-center">
    <a [routerLink]="['/auth/login']" class="text-primary font-medium no-underline hover:underline">
      {{ 'auth.layout.backToLogin' | translate }}
    </a>
  </div>
</app-auth-card>
